import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';
import { dropTask } from 'ember-concurrency';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import FollowingApi from 'mewe/api/following-api';
import ProfileStore from 'mewe/stores/profile-store';
import ContactsApi from 'mewe/api/contacts-api';

export default class AppProfile extends Component {
  @service account;
  @service router;

  constructor() {
    super(...arguments);
    this.getUserDetails();

    if (this.doWindowScroll) {
      window.scrollTo(0, 0);
    }
  }

  get isFollowingRequestReceived() {
    return isPresent(this.args.model.contact.followRequestReceived);
  }

  get isMyProfile() {
    return this.args.model.isMyProfile;
  }

  get doWindowScroll() {
    // Scroll whole window to top on index/posts routes of profile.
    // On other subroutes the scroll is handled by the {{scroll-to}} modifier added to the NavSimple component.
    const routesWithoutMobileScroll = ['app.publicid.index', 'app.publicid.posts'];
    return ~routesWithoutMobileScroll.indexOf(this.router.currentRouteName);
  }

  @action
  userUpdated() {
    this.getUserDetails();
  }

  getUserDetails() {
    const userId = this.args.model.contact.id;

    ContactsApi.getUserDetails({ userId, details: true })
      .then((data) => {
        ProfileStore.send('handleRawData', data);
      })
      .catch((err) => {
        if (err)
          ProfileStore.send('failToFetchData', {
            uuid: userId,
            error: err.data,
          });
      });
  }

  @dropTask
  *acceptFollowRequest() {
    let data = yield FollowingApi.acceptRequestSent(this.args.model.contact.followRequestReceived);
    if (data?.limitReached) {
      this.account.followLimitPopup();
      return
    }

    data = data.follow;
    data.followRequestReceived = '';
    data = { ...data, ...data.user };
    delete data.user;
    ProfileStore.send('updateData', data);
  }

  @action
  async declineFollowRequest() {
    await FollowingApi.cancelRequestSent(this.args.model.contact.followRequestReceived);
    ProfileStore.send('updateData', { id: this.args.model.contact.id, followRequestReceived: '' });
  }
}
